import React from "react";
import { useForm } from "react-hook-form";
import Style from "./AddResturantCategoryForm.module.scss";
import { Spinner } from "react-bootstrap";
import { useState } from "react";
import { AddResturantCategoryAPI } from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
const AddResturantCategoryForm = () => {
  const [loadingBtn, setLoadingBtn] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const onsubmit = (data) => {
    setLoadingBtn(true);
    let info = {
      category_english: data.category_english,
      category_persian: data.category_persian,
      file: "",
    };
    AddResturantCategoryAPI(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        setLoadingBtn(false);
        reset();
      } else {
        errorToast(succ.message);
        setLoadingBtn(false);
      }
    });
  };
  return (
    <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
      <input
        className={errors.price ? Style.errorInput : Style.inputPart}
        placeholder={"نام دسته بندی به فارسی"}
        {...register("category_persian", { required: true })}
      />
      <input
        className={errors.price ? Style.errorInput : Style.inputPart}
        placeholder={"نام دسته بندی به انگلیسی"}
        {...register("category_english", { required: true })}
      />
      <button className={Style.btnStyle} type={"submit"}>
        {loadingBtn ? <Spinner animation="border" variant="light" /> : "ثبت"}
      </button>
    </form>
  );
};

export default AddResturantCategoryForm;
